import UAParser from "ua-parser-js";

export default function () {
  'ngInject';

  return input => {
    const agent = UAParser(input);
    return agent.os.name +
      (agent.os.version ? (' ' + agent.os.version) + ', ' : ', ') +
      agent.browser.name + ' ' + agent.browser.version;
  };
}
